import type { RecipeUUID } from '@library/menu-service'

import type { MenuRecipesState } from 'reducers/menu-recipes/recipes'

export const isRecipeLoaded =
  (id: RecipeUUID) =>
  ({ recipesV3 }: MenuRecipesState): boolean =>
    Boolean(recipesV3.recipes[id])
